export default "__VITE_ASSET__75583811__"